"use client";

import { useWeglot } from "react-weglot";
import styles from "@/styles/Header.module.scss";

export const WeglotLangSwitch = ({ weglotID }: { weglotID: string | null }) => {
	const [lang, setLang] = useWeglot(weglotID ? weglotID : "wg_34b899933a00d8f0921efb0619b2d3df4", "de");
	return (
		<div className={`flex flex-h-center margin-right ${styles.langSwitchComponent}`}>
			<button className={`${styles.langSwitchButton} no-button no-translate ${lang === "de" ? styles.langSwitchButtonActive : "not-active"}`} onClick={() => setLang("de")}>
				DE
			</button>
			|
			<button className={`${styles.langSwitchButton} no-button no-translate ${lang === "en" ? styles.langSwitchButtonActive : "not-active"}`} onClick={() => setLang("en")}>
				EN
			</button>
		</div>
	);
};
